import { QUERY_PARAMS } from './constants';
import { getURLSearchParams } from './url';
export class TrackingConfig {
  constructor(appBaseUrl, publicUrlKey, portalId) {
    this.appBaseUrl = appBaseUrl;
    this.publicUrlKey = publicUrlKey;
    this.portalId = portalId;
  }
  getIsHubSpotReferrer() {
    const referrer = document.referrer;
    return referrer.includes('hubspot.com') || referrer.includes('hubspotqa.com');
  }
  getIsTrackingDisabledViaQueryParam() {
    const isTrackingEnabledQueryParam = getURLSearchParams().get(QUERY_PARAMS.TRACK_EVENTS);
    return isTrackingEnabledQueryParam === 'false';
  }
  getIsTrackingEnabled() {
    if (this.getIsHubSpotReferrer()) {
      return [false, 'referrer is hubspot'];
    }
    if (this.getIsTrackingDisabledViaQueryParam()) {
      return [false, 'trackEvents query param is false'];
    }
    return [true, null];
  }
  static init() {
    let appBaseUrl;
    let publicUrlKey;
    let portalId;

    // Get script element if it exists
    const scriptElement = document.getElementById('hubspot-quote-tracking');

    // Try to get values from data attributes first
    if (scriptElement) {
      appBaseUrl = scriptElement.getAttribute('data-app-base-url');
      publicUrlKey = scriptElement.getAttribute('data-public-url-key');
      portalId = scriptElement.getAttribute('data-portal-id');
    }

    // Fall back to meta tags for any missing values
    // TODO: Remove support for meta tags before inbound release
    if (!appBaseUrl) {
      const appBaseUrlMeta = document.querySelector('meta[name="hs-quote-tracking:hubspot-app-base-url"]');
      appBaseUrl = (appBaseUrlMeta === null || appBaseUrlMeta === void 0 ? void 0 : appBaseUrlMeta.getAttribute('content')) || '';
    }
    if (!publicUrlKey) {
      const publicUrlKeyMeta = document.querySelector('meta[name="hs-quote-tracking:public-url-key"]');
      publicUrlKey = (publicUrlKeyMeta === null || publicUrlKeyMeta === void 0 ? void 0 : publicUrlKeyMeta.getAttribute('content')) || '';
    }
    if (!portalId) {
      const portalIdMeta = document.querySelector('meta[name="hs-quote-tracking:portal-id"]');
      portalId = (portalIdMeta === null || portalIdMeta === void 0 ? void 0 : portalIdMeta.getAttribute('content')) || '';
    }
    return new TrackingConfig(appBaseUrl, publicUrlKey, portalId);
  }
}